import {useCallback, useEffect, useState} from 'react'

type QueryFn<T> = () => Promise<T>

export type UseQueryResult<T> = {
  data: T | null
  error: Error | null
  loading: boolean
  refetch: () => void
}

export function useQuery<T>(query: QueryFn<T>): UseQueryResult<T> {
  const [error, setError] = useState<Error | null>(null)
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState<T | null>(null)

  const fetchData = useCallback(() => {
    setLoading(true)
    query().then((data) => {
      setLoading(false)
      setData(data)
    }, (error) => {
      // eslint-disable-next-line no-console
      console.error('Error fetching me:', error)
      setLoading(false)
      setError(error)
    })
  }, [query])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return {data, error, loading, refetch: fetchData}
}
